import React, { useEffect } from 'react';
import { Button } from '@/Components/ui';

export default function UserSelectBox({
  userList,
  setUserList,

  selectedUsers,
  setSelectedUsers,

  search,
  setSearch,

  count,
  setCount,

  isMultiSelect = true,
  title = "Selected Users",
}) {
  return (
    <div className="mb-3">
      <div style={{ maxHeight: 300, overflowY: "auto" }}>
        <h6>{title}</h6>
        {selectedUsers && selectedUsers.length > 0 ? (
          <div style={{ marginBottom: 10 }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 5,
              }}
            >
              {selectedUsers.map((user, index) => (
                <div
                  key={user.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 10,
                    padding: "5px 10px",
                    border: "1px solid #ddd",
                    borderRadius: 5,
                  }}
                >
                  <span
                    style={{
                      marginRight: 10,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedUsers(selectedUsers.filter((item) => item.id !== user.id));
                    }}
                  >
                    {user["이름"] || user["username"]}
                  </span>
                  <div
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedUsers(selectedUsers.filter((item) => item.id !== user.id));
                    }}
                  >
                    <i className="ri-close-fill"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : <div className='mb-2 text-danger'>선택된 회원이 없습니다.</div>}
      </div>
      {/* search users and select */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
        <input
          id="search-bar-0"
          type="text"
          className="form-control search"
          placeholder={`${count} Search...`}
          style={{ width: "100%" }}
          onChange={(e) => {
            setSearch(e.target.value);
            setCount(0);
          }}
          value={search}
        />
        <Button
          
          style={{ marginLeft: 10 }}
          onClick={() => {
            setSearch("");
            setUserList([]);
            setCount(0);
          }}
         color="secondary">
          Clear
        </Button>
      </div>

      <div style={{ maxHeight: 300, overflowY: "auto" }}>
        {userList.map((item, index) => (
          <div
            key={item.id}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <input
              type="checkbox"
              id={`checkbox-${index}`}
              style={{ marginRight: 10 }}
              checked={selectedUsers.find((user) => user.id === item.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  if (isMultiSelect) setSelectedUsers([...selectedUsers, item]);
                  else setSelectedUsers([item]);
                } else {
                  setSelectedUsers(selectedUsers.filter((user) => user.id !== item.id));
                }
              }}
            />
            <label htmlFor={`checkbox-${index}`} style={{ marginRight: 10 }}>
              {item["이름"] || item["username"]}
            </label>
            <label htmlFor={`checkbox-${index}`} style={{ marginRight: 10 }}>
              {item["전화번호"] || item["phone_num"]}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}